import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import MeetingsPage from './MeetingsPage';

type TParams = { id: string, url: string }

function Notification({ match }: RouteComponentProps<TParams>) {
    return (
      <Switch>
        <Route exact path={`${match.url}`} component={MeetingsPage} />
      </Switch>
    );
}

export default Notification;
